import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { LanguageModel } from "@insite/client-framework/Types/ApiModels";

interface Props {
    date: Date;
    language?: LanguageModel | null;
}

/**
 * This component will return a date localized to the language of the session with predefined RightSTORE options. * 
 */
const getLocalizedDate = ({ date, language  }: Props) => {
    return getLocalizedDateTime({
        dateTime: date, 
        language, 
        options: {
            year: "numeric",
            month: "long",
            day: "numeric"
        }
    });
};

export default getLocalizedDate;